import React, { Component, Fragment } from "react";
import DispatchProps from "../../../utils/DispatchProps";
import Actions from "../../../redux/Actions";
import OnboardHelpBox from "./OnboardHelpBox";
import OnboardTimeline, {OnboardTimelineItem} from "./OnboardTimeline";
import OnboardNavigation from "./OnboardNavigation";
import { IRootState } from "../../../store";
import { connect } from "react-redux";
import { History } from "history";
import { SchoolWorkloadConfig } from "../../../models/SchoolWorkloadConfig";
import ApiService from "../../ApiService";
import * as _ from "lodash";
import {MessageBarType } from "office-ui-fabric-react";
import SdsDatePicker from "./OnboardSdsDatePicker";
import moment from "moment";
import School from "../../../models/School";


interface OnboardSdsDatesPageProps {
    tenantId: string;
    schoolCode: string;

    apiService: ApiService;
    history: History;
}

interface OnboardSdsDatesPageState {
    schoolWorkloadConfig?: SchoolWorkloadConfig;
    sdsStartDate?: Date;
    sdsEndDate?: Date;
}

class OnboardSdsDatesPage extends Component<OnboardSdsDatesPageProps & DispatchProps, OnboardSdsDatesPageState> {

    constructor(props: OnboardSdsDatesPageProps & DispatchProps) {
        super(props);
        this.state = {
        };
    }

    async componentDidMount(): Promise<void> {
        if (this.props.tenantId) {
            const schoolWorkloadConfig = await this.props.apiService.getSchoolConfigJson(this.props.tenantId, this.props.schoolCode);

            this.setState({
                schoolWorkloadConfig,
                sdsStartDate: moment(schoolWorkloadConfig.sdsStartDate).toDate(),
                sdsEndDate: moment(schoolWorkloadConfig.sdsEndDate).toDate()
            });
        }
    }

    async componentDidUpdate(prevProps: Readonly<OnboardSdsDatesPageProps & DispatchProps>, prevState: OnboardSdsDatesPageState): Promise<void> {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            const schoolWorkloadConfig = await this.props.apiService.getSchoolConfigJson(this.props.tenantId, this.props.schoolCode);

            this.setState({
                schoolWorkloadConfig,
                sdsStartDate: schoolWorkloadConfig.sdsStartDate,
                sdsEndDate: schoolWorkloadConfig.sdsEndDate
            });
        }
    }

    public save = async (): Promise<boolean> => {
        if (this.state.schoolWorkloadConfig === undefined) {
            return false;
        }

        const updatedConfig = _.cloneDeep(this.state.schoolWorkloadConfig);

        updatedConfig.sdsStartDate = moment(this.state.sdsStartDate).utc(true).toDate();
        updatedConfig.sdsEndDate = moment(this.state.sdsEndDate).utc(true).toDate();

        try {
            const savedSchoolWorkloadConfig = await this.props.apiService.putSchoolConfigJson(this.props.tenantId, this.props.schoolCode, updatedConfig);

            this.setState({
                schoolWorkloadConfig: savedSchoolWorkloadConfig
            });

            await this.props.dispatch(Actions.showMessageBar(`Saved SDS dates to config.`, MessageBarType.success));
        }
        catch (e) {
            console.log(e);
            await this.props.dispatch(Actions.showMessageBar(`Failed to save dates to config: ${e.message}`, MessageBarType.error));
        }

        return true;
    }

    public render(): JSX.Element {

        return (
            <Fragment>
                <OnboardHelpBox currentTimelineItemKey={"sds-dates"}/>
                <OnboardTimeline tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} apiService={this.props.apiService}>
                    {(school: School,timelineItems: OnboardTimelineItem[]) => {
                        return (
                            <Fragment>
                                <div className="onboard-timeline-content">

                                    <SdsDatePicker
                                        onSdsStartDateChanged={(sdsStartDate: Date) => this.setState({sdsStartDate})}
                                        onSdsEndDateChanged={(sdsEndDate: Date) => this.setState({sdsEndDate})}
                                        startDate={this.state.sdsStartDate!}
                                        endDate={this.state.sdsEndDate!}
                                    />

                                </div>
                                <OnboardNavigation currentTimelineItemKey={"sds-dates"} timelineItems={timelineItems} completeItem={this.save}
                                                   enableNext={true} enableSave={true} history={this.props.history}
                                                   tenantId={this.props.tenantId} schoolCode={this.props.schoolCode}/>

                            </Fragment>
                        );
                    }}
                </OnboardTimeline>
            </Fragment>
        )
    }
}

export default connect(
    (state: IRootState, ownProps: any): OnboardSdsDatesPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId,
            schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history
        };
    }
)(OnboardSdsDatesPage)
